import { createFileRoute, redirect } from "@tanstack/react-router";
import { ensureElementVisible } from "@/lib/route-guards";

// Stare linki (`/konfiguracja/issue-resolve/{n}?draft=…`) prowadzą do skrzynki
// Robaczka; `q` = numer issue, który skrzynka dopasowuje też po `githubIssueNumber`.
export const Route = createFileRoute("/_auth/konfiguracja/issue-resolve/$number")({
	beforeLoad: async ({ context, location, params }) => {
		await ensureElementVisible(context.queryClient, "sidebar.helpdesk.obsluga", location.href);
		throw redirect({
			to: "/helpdesk",
			search: { category: "robaczek", status: "all", q: params.number },
			replace: true,
		});
	},
});
